import { render, staticRenderFns } from "./UpcomingSessions.vue?vue&type=template&id=7187ea40&scoped=true&"
import script from "./UpcomingSessions.vue?vue&type=script&lang=ts&"
export * from "./UpcomingSessions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7187ea40",
  null
  
)

export default component.exports